import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import { navData } from '../../nav-config-main';
import { NavList } from '../nav/mobile/nav-mobile-list';
import { AccountDrawer } from '../../components/account-drawer';
import { AddProductButton } from '../../components/add-product-button';
import { ShoppingCartButton } from '../../components/shopping-cart-button';

// ----------------------------------------------------------------------

export function FooterMobile(t0) {
  const $ = _c(8);
  const {
    sx
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      py: 1.5,
      width: 1,
      bottom: -1,
      zIndex: 999,
      position: "fixed",
      backgroundColor: "background.paper"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== sx) {
    t2 = Array.isArray(sx) ? sx : [sx];
    $[1] = sx;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = [t1, ...t2];
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box sx={{
      width: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-evenly"
    }}>{navData.map(_temp)}<AddProductButton /><ShoppingCartButton /><AccountDrawer /></Box>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Box component="footer" sx={t3}>{t4}</Box>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp(list) {
  return <NavList onlyIcon={true} key={list.title} data={list} />;
}